import React from 'react'
import './section.scss'

const Section = ({ children, variant="black", id }) => {

    return (
        <div className="section-wrapper" style={{background: variant === "grey" && "rgba(255, 255, 255, 0.1)"}} id={id}>
            <div className="section-content">
                {children}
            </div>
        </div>
    )
}

export default Section